export default {
  reviews: [],
  reviewResponse: null
};
